import {createSvgIcon} from "@mui/material";

const FilterIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.7894 2.75H2.81973L7.96314 9.99565L7.96415 9.99702C7.96473 9.99782 7.96537 9.99871 7.96607 9.99967C8.24867 10.3837 8.4016 10.8481 8.40231 11.3252L8.40231 11.3263L8.40231 17.2133L11.2069 16.144V11.3263V11.3252C11.2076 10.8481 11.3605 10.3838 11.6428 9.99984L16.7894 2.75ZM16.7894 2.75L11.6459 9.99568L11.6449 9.99706C11.6445 9.99758 11.6441 9.99814 11.6436 9.99873L11.6436 9.99872L11.6429 9.99983L16.7894 2.75ZM16.8668 2.70626L16.8668 2.70632L16.8668 2.70626ZM11.6494 9.99089C11.6503 9.9897 11.6507 9.9891 11.6502 9.98978L11.6494 9.99089Z"
      stroke="currentColor" strokeWidth="1.5"/>
  </svg>,
  'Filter'
)

export default FilterIcon;
